import {
  Button,
  Card,
  FormField,
  FormGrid,
  FormRow,
  InfoCard,
  Link,
} from "@endya-conformite/ui-kit";
import DownloadIcon from "@endya-conformite/ui-kit/src/assets/icons/download.svg?react";
import { ReactNode } from "react";
import styles from "./AdhesionSocieteListCorrection.module.scss";

type EntrepriseImportEmptyProps = {
  importButton: ReactNode;
};

function Step1() {
  return (
    <div>
      <Link to="/modele_societe.xlsx" target="_blank">
        <Button
          variant="text"
          icon={<DownloadIcon />}
          className={styles.download}
        >
          Télécharger et remplir le fichier modèle
        </Button>
      </Link>
    </div>
  );
}

export function EntrepriseImportEmpty({
  importButton,
}: EntrepriseImportEmptyProps) {
  return (
    <Card>
      <FormGrid disableHorizontalGutter>
        <FormRow>
          <FormField>
            <InfoCard type="warning">
              Aucune donnée n&apos;a été importée.
            </InfoCard>
          </FormField>
        </FormRow>
        <FormRow>
          <FormField>
            <h2 className={styles.titleProcedure}>Comment procéder ?</h2>
          </FormField>
        </FormRow>
        <FormRow>
          <FormField>
            <div className={styles.container}>
              <span className={styles.step}>1</span>
              <Step1 />
            </div>
          </FormField>
        </FormRow>

        <FormRow>
          <FormField>
            <div className={styles.container}>
              <span className={styles.step}>2</span>
              {importButton}
            </div>
          </FormField>
        </FormRow>
      </FormGrid>
    </Card>
  );
}
